function getFragmentName(): string {
    return typeof __MFE_NAME__ === 'undefined' ? 'fragment' : __MFE_NAME__;
}

export { getFragmentName };
